<div class="notification-container">
  <a id="notifications" role="button" (click)="showNotificationBanner()">
    <img src="assets/images/icons/notifications_icon.svg" alt="notifications_icon" class="menu_icon">
    
  </a>
  <ng-container *ngIf="activePoint">
    <span class="notification-badge"></span>
  </ng-container>
  
  <div class="notification-dialog" *ngIf="showNotificationDialog">
    <div class="title-div">
      <div class="title">{{"NOTF_TITLE" | translate}}</div>
        <ng-container *ngIf="activeButton === 1 && this.notificationConnectionService.getNoReadNotificationLength() > 0;">
          <div class="div-select-all" (click)="selectAll('read')">
            <div class="select-all">{{"select-all" | translate}}</div>
            <div class="div-img-select-all">
              <img src="assets/images/icons/check_outline.svg" class="img-select-all" alt="Select all like read" loading="lazy">
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="activeButton === 2 && this.notificationConnectionService.getReadNotificationLength() > 0;">
          <div class="div-select-all" (click)="selectAll('delete')">
            <div class="select-all">{{"delete-all" | translate}}</div>
            <div class="div-img-select-all">
              <img src="assets/images/icons/delete_all.svg" width="20" height="20" class="img-select-all" alt="Delete all" loading="lazy">
            </div>
          </div>
        </ng-container>
    </div>
    <div class="buttons-container">
      <a class="button" [class.active]="activeButton === 1" (click)="setNotifications($event, 1)">{{"NO_READ_NOTF" | translate}}</a>
      <a class="button right" [class.active]="activeButton === 2" (click)="setNotifications($event, 2)">{{"READ_NOTF" | translate}}</a>
    </div>
    <section class="notification-section">
      <ng-container *ngIf="activeButton === 1; else ReadNotification">
        <div *ngFor="let noti of this.notificationConnectionService.getNoReadNotification()">
          <div class="notification-section-box">
            <div class="title-description-container">
              <div [className]="noti.tituloEs.length > 35 ? 'notification-section-title-long' : 'notification-section-title'">
                {{currentLang == "es" ? textUtils.capitalizeFirsLetter(noti.tituloEs) : textUtils.capitalizeFirsLetter(noti.tituloEn)}}
              </div>
              <div class="notification-section-description">
                <span class="notification-span" [innerHTML]="noti.tipoNotificacion| buildNotificationTemplate : translations.NOTIFICATIONS : noti.contenido"></span>
                <span *ngIf="noti.tipoNotificacion != 'BBD_NBD' && noti.tipoNotificacion != 'MSJ_BDVA' && noti.tipoNotificacion !='AUT_PAG' && noti.tipoNotificacion !='AUT_DEST'">
                  {{currentLang == "es" ? "Da" : ""}} <a (click)="buildLink()">{{"click aqui" | translate}}</a> {{"CONSULT_TEXT" | translate}}
                </span>
                <span *ngIf="noti.tipoNotificacion =='AUT_PAG' || noti.tipoNotificacion =='AUT_DEST' " class="pending-authx-span">
                      {{ 'Tienes'|translate }} <p class="auth-pending-label">{{ 'autorizaciones pendientes.'|translate }}</p> {{ 'Revisalas y'|translate }} <a (click)="openModalPendingPaymentsToAuth(noti?.contenido, noti?.idNotificacion, noti?.tipoNotificacion)" class="auth-center-noti-label">
                      {{'autorizalas en el Centro de notificaciones.'|translate}}</a>
                </span>
              </div>
            </div>
            <div class="notification-section-time">
              <div>{{noti.msCreacion | msConverter: currentLang}}</div>
              <input type="radio" name="setReadNotification" (change)="setReadNotification(noti.idNotificacion)">
            </div>
          </div>
          <hr>
        </div>
      </ng-container>
      <ng-template #ReadNotification>
        <div *ngFor="let noti of this.notificationConnectionService.getReadNotification()">
          <div class="notification-section-box">
            <div class="pe-2">
              <div class="notification-section-title">
                {{currentLang == "es" ? noti.tituloEs : noti.tituloEn}}
              </div>
              <div class="notification-section-description">
                <span [innerHTML]="noti.tipoNotificacion| buildNotificationTemplate : translations.NOTIFICATIONS : noti.contenido"></span>
                <span *ngIf="noti.tipoNotificacion != 'BBD_NBD' && noti.tipoNotificacion != 'MSJ_BDVA' && noti.tipoNotificacion !='AUT_PAG' && noti.tipoNotificacion !='AUT_DEST'">
                  {{currentLang == "es" ? "Da" : ""}} <a (click)="buildLink()">{{"click aqui" | translate}}</a> {{"CONSULT_TEXT" | translate}}
                </span>
                <span *ngIf="noti.tipoNotificacion =='AUT_PAG' || noti.tipoNotificacion =='AUT_DEST'" class="pending-authx-span">
                      {{ 'Tienes'|translate }}
                      <p class="auth-pending-label">{{ 'autorizaciones pendientes.'|translate }}</p>
                      {{ 'Revisalas y'|translate }}
                      <p class="auth-center-noti-label">{{'autorizalas en el Centro de notificaciones.'|translate}}</p>
                </span>
              </div>
            </div>
            <div class="notification-section-time  d-flex align-items-center">
              <span class="cursor-pointer icon" (click)="deleteNotifications(noti.idNotificacion)">
                  <img src="assets/images/icons/delete_one.svg" width="18" height="18" alt="Delete" loading="lazy">
              </span>
            </div>
          </div>
          <hr>
        </div>
      </ng-template>
    </section>
  </div>
</div>
